module.exports = __webpack_public_path__ + "img/hohlsaum_beige_ral1014.b7a83f0b.jpg";